import { createGlobalState } from '@vueuse/shared';
import type { Ref } from 'vue';
import { ref } from 'vue';
import type { PeriodAbbrevEnum } from '@/constants/PeriodAbbrevEnum';

export const useTeamSettingsGlobalState = createGlobalState(
  (): {
    periodPickerDisplayPreferences: Ref<PeriodAbbrevEnum[]>;
    arePeriodPickerDisplayPreferencesLoading: Ref<boolean>;
  } => {
    const periodPickerDisplayPreferences = ref<PeriodAbbrevEnum[]>([]);
    const arePeriodPickerDisplayPreferencesLoading = ref(true);

    return {
      periodPickerDisplayPreferences,
      arePeriodPickerDisplayPreferencesLoading,
    };
  },
);
